import React, { Fragment } from "react";
import { Field, useForm } from "react-final-form";
import { OnChange } from "react-final-form-listeners";

// Web Final Form Components
import { FormGroup, Label, Col } from "reactstrap";
import { InputField, ReactSelect, ToggleField, required } from "modules/4_final_form/web";
import { SmartSelect } from "modules/4_final_form/mobile";

import { connect } from "react-redux";
import _ from "lodash";

export const EmployeeFieldAttributes = ({ fieldName, namesUsed }) => {
  const form = useForm();

  return (
    <Fragment>
      <FormGroup row>
        <Label md={3}>Label</Label>
        <Col md={8}>
          <Field name={`${fieldName}.label`} component={InputField} />
          <OnChange name={`${fieldName}.label`}>
            {(value, previous) => {
              if (value) {
                let name = _.snakeCase(value);
                // Check first character is a number
                if (name.match(/^\d/)) {
                  name = `_${name}`;
                }
                form.change(`${fieldName}.name`, name);
              }
            }}
          </OnChange>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>Name</Label>
        <Col md={8}>
          <Field
            name={`${fieldName}.name`}
            component={InputField}
            validate={(value, values) => {
              if (!value) {
                return "is required";
              }
              if (namesUsed.includes(value)) {
                return "must be unique";
              }
            }}
            convertToLowerCase
            lettersOnly
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>Placeholder</Label>
        <Col md={8}>
          <Field name={`${fieldName}.placeholder`} component={InputField} />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>Required Field</Label>
        <Col md={8}>
          <Field name={`${fieldName}.required`} component={ToggleField} />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>On Dashboard</Label>
        <Col md={8}>
          <Field name={`${fieldName}.on_dashboard`} component={ToggleField} />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>On Report</Label>
        <Col md={8}>
          <Field name={`${fieldName}.on_report`} component={ToggleField} />
        </Col>
      </FormGroup>
    </Fragment>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    employees: state.employees,
  };
};

export let EmployeeFieldForm = (props) => {
  const { required: isRequired, preview, name, label, prefixName, disabled, employees } = props;


  const sortedEmployees = _.sortBy(employees, ["last_name", "first_name"]);
  return (
    <Fragment>
      <FormGroup row>
        <Label md={2}>
          {label}
          {isRequired && "*"}
        </Label>
        <Col md={10}>
          <Field
            name={`${prefixName}.${name}`}
            disabled={preview || disabled}
            component={ReactSelect}
            options={_.map(sortedEmployees, (p) => {
              return { value: p.id, label: p.display_name };
            })}
            placeholder="Select Employee"
            validate={isRequired && !preview ? required : null}
          />
        </Col>
      </FormGroup>
    </Fragment>
  );
};
EmployeeFieldForm.defaultProps = {
  prefixName: "data",
};

EmployeeFieldForm = connect(mapStateToProps)(EmployeeFieldForm);

export let MobileEmployeeFieldForm = (props) => {
  const { required: isRequired, preview, name, label, prefixName, disabled, employees, placeholder } = props;

  const sortedEmployees = _.sortBy(employees, ["last_name", "first_name"]);

  return (
    <Field
      name={`${prefixName}.${name}`}
      label={label}
      disabled={preview || disabled}
      component={SmartSelect}
      options={_.map(sortedEmployees, (p) => {
        return { value: p.id, label: p.display_name };
      })}
      searchbar
      searchbarPlaceholder="Search by name"
      placeholder={placeholder || "Select Employee"}
      validate={isRequired && !preview ? required : null}
      valueName="value"
      labelName="label"
      style={{ backgroundColor: "rgb(225, 226, 236)", margin: "12px", borderBottom: "1px solid" }}
    />
  );
};

MobileEmployeeFieldForm.defaultProps = {
  prefixName: "data",
};

MobileEmployeeFieldForm = connect(mapStateToProps)(MobileEmployeeFieldForm);
